import nl2br from './nl2br'
import truncate from './truncate'

export default {
  nl2br,
  truncate
}
